<script>
import { BInputGroupPrepend } from "bootstrap-vue";

export default {
  extends: BInputGroupPrepend
};
</script>